// Combines date and time into a single string
// Formats date from 'yyyy-MM-dd' and 'HH:mm' to 'yyyyMMddHHmm'
const formatAndCombineDatetime = (date, time) => {
  const formattedDate = date.replace(/-/g, "");
  const formattedTime = time.replace(/:/g, "");
  return formattedDate + formattedTime;
};

export default formatAndCombineDatetime;
